import {all, call, put, takeEvery} from "redux-saga/effects";
import categoryApi from "@api/category";
import {
    CategoriesActionTypes, fetchError, fetchSuccess, createError, createSuccess, deleteError, deleteSuccess,
    updateSuccess, updateError
} from "@actions/category";
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
    try {
        const res = yield call(categoryApi.getList, payload);
        yield put(fetchSuccess(res));
    }
    catch (err) {
        yield put(fetchError(err));
    }
}


function* handleDelete({payload}: ReduxAction) {
    try {
        yield call(categoryApi.delete, payload);
        yield put(deleteSuccess(payload));
    }
    catch (err) {
        yield put(deleteError(err))
    }
}


function* handleCreate({payload}: ReduxAction) {
    try {
        const {data} = yield call(categoryApi.create, payload);
        payload.onSuccessCallback && payload.onSuccessCallback(data);
        yield put(createSuccess(data))
    }
    catch (err) {
        yield put(createError(err));
        payload.onErrorCallback && payload.onErrorCallback(err);
    }
}


function* handleUpdate({payload}: ReduxAction) {
    try {
        const {data} = yield call(categoryApi.update, payload);
        payload.onSuccessCallback && payload.onSuccessCallback();
        yield put(updateSuccess(data))
    }
    catch (err) {
        yield put(updateError(err));
        payload.onErrorCallback && payload.onErrorCallback(err);
    }
}


/*************************************************************
 **************************************************************/


function* categoriesSaga() {
    yield all([
        yield takeEvery(CategoriesActionTypes.FETCH_REQUEST, handleFetch),
        yield takeEvery(CategoriesActionTypes.DELETE_REQUEST, handleDelete),
        yield takeEvery(CategoriesActionTypes.CREATE_REQUEST, handleCreate),
        yield takeEvery(CategoriesActionTypes.UPDATE_REQUEST, handleUpdate),
    ])
}

export default categoriesSaga
